import script from "./NombreDeBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NombreDeBox.vue?vue&type=script&setup=true&lang=js"

import "./NombreDeBox.vue?vue&type=style&index=0&id=6c9fde1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9fde1c"]])

export default __exports__